import { Component, Input, OnInit } from '@angular/core';
import { IInvitation } from '@app/models/signup';
import { INVITATIONB2BCLIENTSTEPSTYPE, TInvitationB2BClientSteps } from '../../invitation-b2b-client.service';

@Component({
  selector: 'app-invitation-b2b-client-already-checked',
  templateUrl: './invitation-b2b-client-already-checked.component.html',
  styleUrls: ['./invitation-b2b-client-already-checked.component.scss']
})
export class InvitationB2BClientAlreadyCheckedComponent {
  @Input() invitation: IInvitation;
  @Input() status: TInvitationB2BClientSteps;

  endpoints = window['ENDPOINTS'];
  account = window['CURRENT_ACCOUNT'];
  invitationStep = INVITATIONB2BCLIENTSTEPSTYPE;

  get isAlreadyAccepted() {
    return this.status === this.invitationStep.invitationB2bAlreadyAccepted;
  }
  get isAlreadyRejected() {
    return this.status === this.invitationStep.invitationB2bAlreadyRejected;
  }
  get imageLink() {
    return this.isAlreadyAccepted ? 'assets/images/partner/already_accepted.svg' : 'assets/images/partner/already_rejected.svg';
  }
  get managerLink() {
    return this.isAlreadyAccepted
      ? `${this.endpoints?.manager}/v3/${this.account.id}/ng/accounts/client-space/partner/${this.invitation.extras.partnership_id}`
      : `${this.endpoints?.manager}/v3/${this.account.id}/ng/accounts/client-space/list`;
  }
}
